import {cva} from 'class-variance-authority'

// v3 "filled" field (MUI TextField, filled variant): mint fill, bottom-border only,
// top corners rounded, with a label that floats inside the box.
export const textFieldVariants = cva(
  'relative flex w-full gap-1 rounded-t-[4px] border-b border-solid px-3 py-2 transition-colors',
  {
    variants: {
      // A single-line field centres its row; a multiline one grows downward, so
      // the icons pin to the first line instead of drifting to the box's middle.
      multiline: {
        true: 'items-start',
        false: 'items-center',
      },
      isError: {
        true: 'border-error bg-[rgba(255,128,140,0.16)]',
        false: 'bg-[#f6f9f8] border-divider focus-within:border-primary',
      },
      disabled: {
        // No focus colour change and a dimmed, non-interactive surface.
        true: 'bg-[#f6f9f8] border-divider cursor-not-allowed focus-within:border-divider',
      },
    },
    defaultVariants: {
      isError: false,
      multiline: false,
    },
  },
)

export const textFieldIconWrapperClass =
  'flex shrink-0 items-center justify-center size-6 text-text-secondary [&_svg]:size-6'

export const textFieldHelperClass = 'px-3 text-[12px] leading-4 tracking-[0.4px]'
